import { FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { BsInstagram, BsFacebook, BsLinkedin } from 'react-icons/bs';

const SOCIAL_ICONS = {
  whatsapp: { Icon: FaWhatsapp, hoverBg: 'hover:bg-green-800', iconColor: 'text-green-800' },
  twitter: { Icon: FaXTwitter, hoverBg: 'hover:bg-black', iconColor: 'text-stone-600' },
  instagram: { Icon: BsInstagram, hoverBg: 'hover:bg-[#E4405F]', iconColor: 'text-stone-600' },
  linkedin: { Icon: BsLinkedin, hoverBg: 'hover:bg-blue-600', iconColor: 'text-stone-600' },
  facebook: { Icon: BsFacebook, hoverBg: 'hover:bg-blue-600', iconColor: 'text-stone-600' }
};

const SocialIcon = ({ platform, url, title }) => {
  const { Icon, hoverBg, iconColor } = SOCIAL_ICONS[platform];
  return (
    <a href={url}
       title={title}
       className={`p-3 rounded-full transition-colors duration-300 group bg-stone-100 ${hoverBg}`}>
      <Icon className={`w-5 h-5 ${iconColor} transition-colors duration-300 group-hover:text-white`} />
    </a>
  );
};

export default function SocialIcons({
  socialMedia,
  translationFunc,
  translationKeyPrefix = 'contact.social',
  variant = 'default',
  isScrolled = false
}) {
  return (
    <div className={
      variant === 'header'
        ? 'flex gap-4'
        : 'flex flex-wrap gap-4 justify-center'
    }>
      {Object.entries(socialMedia).map(([platform, url]) => {
        if (!url) return null;

        const { Icon, hoverBg, iconColor } = SOCIAL_ICONS[platform];

        // For 'header' variant, we’ll use simpler classes and a color check
        if (variant === 'header') {
          const colorClass = !isScrolled ? 'text-white' : 'text-[var(--primary-color)]';
          return (
            <a
              key={platform}
              href={url}
              title={translationFunc(`${translationKeyPrefix}.${platform}`)}
              className={`text-xs sm:text-sm md:text-base ${colorClass}`}
            >
              <Icon />
            </a>
          );
        }

        // Default variant (existing design)
        return (
          <a
            key={platform}
            href={url}
            title={translationFunc(`${translationKeyPrefix}.${platform}`)}
            className={`p-3 rounded-full transition-colors duration-300 group bg-stone-100 ${hoverBg}`}
          >
            <Icon className={`w-5 h-5 ${iconColor} transition-colors duration-300 group-hover:text-white`} />
          </a>
        );
      })}
    </div>
  );
}